import { checkEquality } from '../../../utils/functions'

export function dragItems(result, levels) {
	const [sourceLevelIndex, sourceGroupIndex] = result.source.droppableId.split('-')
	const [endLevelIndex, endGroupIndex] = result.destination.droppableId.split('-')

	const movedNode = {
		...levels[sourceLevelIndex]?.groups[sourceGroupIndex]?.nodes[result.source.index],
	}
	const replacedNode = {
		...levels[endLevelIndex]?.groups[endGroupIndex]?.nodes[result.destination.index]
	}

	const updatedMovedNode = {
		...movedNode,
		name: replacedNode.name,
		participant: replacedNode.participant,
		playerUid: replacedNode.playerUid,
		doubleUid: replacedNode.doubleUid,
		dependsOnUid: replacedNode.dependsOnUid,
		rating: replacedNode.rating
	}

	const updatedReplacedNode = {
		...replacedNode,
		name: movedNode.name,
		participant: movedNode.participant,
		playerUid: movedNode.playerUid,
		doubleUid: movedNode.doubleUid,
		dependsOnUid: movedNode.dependsOnUid,
		rating: movedNode.rating
	}

	return {
		sourceLevelIndex,
		endLevelIndex,
		endGroupIndex,
		sourceGroupIndex,
		endIndex: result.destination.index,
		sourceIndex: result.source.index,
		movedNode: updatedMovedNode,
		replacedNode: updatedReplacedNode
	}
}

function checkNodesEquality(levels, immutableLevels) {
	// если в текущем состоянии этапа какая-то нода отличается от первоначальной, то возвращаем false
	return !levels?.some((lvl, lvlIndex) => {
		return lvl.groups.some((grp, grpIndex) => {
			const immutableGroup = immutableLevels[lvlIndex]?.groups[grpIndex]

			if (!checkEquality(grp, immutableGroup)) {
				return true
			}

			return false
		})
	})
}

function cleanPlacedAttribute(participantsList) {
	return participantsList.map((item) => {
		return {
			...item,
			placed: false
		}
	})
}

function checkLevelsAndGroups(levels, levelsMemory) {
	const levelsMemoryLength = levelsMemory.length
	const levelsLength = levels.length

	if (levelsMemoryLength !== levelsLength) return true

	const groupMemory = levelsMemory.map(level => {
		return level.groups
	})
	const groupMemoryLength = groupMemory[0].length

	const group = levels.map(level => {
		return level.groups
	})
	const groupLength = group[0].length

	if (groupMemoryLength !== groupLength) {
		return true
	} else {
		let isDifferent = false

		levelsMemory.forEach((groups, groupsIndex) => {
			groups.groups.forEach((group, groupIndex) => {
				if ((group.participants_max !== levels[groupsIndex].groups[groupIndex].participants_max)
					|| (group.type !== levels[groupsIndex].groups[groupIndex].type)) {
					isDifferent = true
				}
			})
		})

		return isDifferent
	}
}

export {
	cleanPlacedAttribute,
	checkLevelsAndGroups,
	checkNodesEquality
}